<template>
  <b-modal
    id="configEndpointSchemaModal"
    ref="schemaConfigModal"
    :title="`Edit '${schemaName}' Schema`"
    ok-title="Back"
    ok-only
    @show="onShowModal"
    @hide="onHideModal"
  >
    <b-form class="p-3">
      <div class="row">
        <div class="read-only-columns col-6">
          <input-widget
            v-for="field in readOnlyFields"
            :id="`${schemaName}-schema-${field.name}-field`"
            :model="form"
            :disabled="true"
            :field="field"
            :align="['radio-group', 'text', 'number'].includes(field.type) ? 'row' : 'column'"
            class="col-md-6"
            :class="{'col-md-12': ['radio-group', 'text', 'number'].includes(field.type)}"
          />
        </div>
        <div class="editable-columns col-6">
          <input-widget
            v-for="field in editableFiedls"
            :id="`${schemaName}-schema-${field.name}-field`"
            :model="form"
            :field="field"
            :align="['radio-group', 'text', 'number'].includes(field.type) ? 'row' : 'column'"
            class="col-md-6"
            :class="{'col-md-12': ['radio-group', 'text', 'number'].includes(field.type)}"
          />
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../../core/components/ContentSpinner.vue';
import InputWidget from '../../../core/components/complex-table/components/InputWidget.vue';
import ShowError from '../../../core/components/ShowError.vue';
import DataManagementModal from '../../../core/components/complex-table/DataManagementModal.vue';

const {mapState, mapActions} = createNamespacedHelpers('connectorScreen');

const {
  mapState: mapDataManagementState,
  mapActions: mapDataManagementActions,
} = createNamespacedHelpers('dataManagement');

export default {
  name: 'EndpointConfigFormModal',
  components: {ShowError, InputWidget, ContentSpinner, DataManagementModal},
  props: {
    schema: {type: Object, default: () => {}},
    schemaName: {type: String, default: ''},
    schemaDataType: {type: String, default: 'default'},
    showModal: {type: Boolean, default: false},
  },
  data() {
    return {
      form: {},
      readOnlyFields: {
        columnName: {
          type: 'text',
          label: 'Column Name',
          name: 'columnName',
          disabled: true,
        },
        jsonPath: {
          type: 'text',
          label: 'Json Path',
          name: 'jsonPath',
          disabled: true,
        },
        ordinalPosition: {
          type: 'number',
          label: 'Ordinal Position',
          name: 'ordinalPosition',
          disabled: true,
        },
        dataType: {
          type: 'text',
          label: 'Data Type',
          name: 'dataType',
          disabled: true,
        },
        isBusinessKey: {
          type: 'radio-group',
          label: 'Is Business Key',
          name: 'isBusinessKey',
          disabled: true,
          data: {
            options: [
              {text: false, value: false},
              {text: true, value: true},
            ],
          },
        },
        isJsonStoredAsString: {
          type: 'radio-group',
          label: 'Is Json Stored As String',
          name: 'isJsonStoredAsString',
          disabled: true,
          data: {
            options: [
              {text: false, value: false},
              {text: true, value: true},
            ],
          },
        },
        isLineBreak: {
          type: 'radio-group',
          label: 'Is Line Break',
          name: 'isLineBreak',
          disabled: true,
          data: {
            options: [
              {text: false, value: false},
              {text: true, value: true},
            ],
          },
        },
        isNullable: {
          type: 'radio-group',
          label: 'Is Nullable',
          name: 'isNullable',
          disabled: true,
          data: {
            options: [
              {text: false, value: false},
              {text: true, value: true},
            ],
          },
        },
        isPercentage: {
          type: 'radio-group',
          label: 'Is Percentage',
          name: 'isPercentage',
          disabled: true,
          data: {
            options: [
              {text: false, value: false},
              {text: true, value: true},
            ],
          },
        },
        useColumnNameAsDisplayName: {
          type: 'radio-group',
          label: 'Use Column Name As Display Name',
          name: 'useColumnNameAsDisplayName',
          disabled: true,
          data: {
            options: [
              {text: false, value: false},
              {text: true, value: true},
            ],
          },
        },
      },
      editableFiedls: {
        applyRounding: {
          type: 'radio-group',
          label: 'Apply Rounding',
          name: 'applyRounding',
          data: {
            options: [
              {text: false, value: false},
              {text: true, value: true},
            ],
          },
        },
        formatString: {
          type: 'text',
          label: 'Format String',
          name: 'formatString',
        },
        decimalsToDisplay: {
          type: 'number',
          label: 'Decimals To Display',
          name: 'decimalsToDisplay',
        },
        maxValue: {
          type: 'number',
          label: 'Max Value',
          name: 'maxValue',
        },
        maximumLength: {
          type: 'number',
          label: 'Maximum Length',
          name: 'maximumLength',
        },
        minValue: {
          type: 'number',
          label: 'Min Value',
          name: 'minValue',
        },
        precision: {
          type: 'number',
          label: 'Precision',
          name: 'precision',
        },
        scale: {
          type: 'number',
          label: 'Scale',
          name: 'scale',
        },
      },
    };
  },
  methods: {
    ...mapActions(['hideEndpointModal', 'saveEndpoint', 'updateSalesforceEndpoint']),
    onShowModal() {
      this.$nextTick(() =>
        this.$nextTick(() => this.form = {...this.schema}),
      );
    },
    onHideModal() {
      const schemaObject = {...this.form};
      this.form = {};
      this.$emit('onHideModal', schemaObject);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-dialog {
  max-width: 800px;
}
</style>
